export var CurveType;
(function (CurveType) {
    CurveType[CurveType["Line"] = 0] = "Line";
    CurveType[CurveType["BarGroup"] = 1] = "BarGroup";
    CurveType[CurveType["BarStack"] = 2] = "BarStack";
})(CurveType || (CurveType = {}));
